/**
 * 文件上传
 * Created by HeMengJiao on 2019/10/30.
 */
import axios from 'axios';
import AppConfig from '../appConfig';
import store from '../store/store';

export default {
  post(url, data, config = {}) {
    // qs.stringify(data)
    config.headers = config.headers ? config.headers
      : {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
      }
    config.headers['token'] = store.state.token ? store.state.token : ''

    return axios({
      method: 'post',
      baseURL: AppConfig.API.UPLOAD_URL,
      url,
      data: data,
      timeout: 10000,
      headers: config.headers
    })
      .then((response) => {
        return response
      })
      .catch((err) => {
        return err
      })
  }
}



// WEBPACK FOOTER //
// ./src/factory-api/upload-https.js